(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-sound-enabled.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-sound-enabled.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const USERS_PREFERRED_SOUND_STATUS_KEY = 'userSoundStatus';
const TICKET_GAMES_SCRATCH_GAMES_DOMAIN = 'svs.ticketgames.ticketUtility.scratchGames';
const EXPIRATION = svs.components.Storage.constants.EXPIRES_24H;
const useSoundEnabled = _ref => {
  let ticketInfo = _ref.ticketInfo;
  const shouldSaveUsersPreferredSoundStatus = () => {
    const catergories = ['Triss', 'Skrapspel'];
    return ticketInfo.hasSound && catergories.includes(ticketInfo.category);
  };
  const getUsersPreferredSoundStatus = () => {
    if (shouldSaveUsersPreferredSoundStatus()) {
      return svs.components.Storage.browser.get(USERS_PREFERRED_SOUND_STATUS_KEY, TICKET_GAMES_SCRATCH_GAMES_DOMAIN);
    }
  };
  const setUsersPreferredSoundStatus = soundStatus => {
    if (shouldSaveUsersPreferredSoundStatus()) {
      return svs.components.Storage.browser.set(USERS_PREFERRED_SOUND_STATUS_KEY, TICKET_GAMES_SCRATCH_GAMES_DOMAIN, soundStatus, EXPIRATION);
    }
  };
  const hasSound = ticketInfo.hasSound,
    hasSoundDefaultOn = ticketInfo.hasSoundDefaultOn;
  const _useState = useState(getUsersPreferredSoundStatus()),
    _useState2 = _slicedToArray(_useState, 1),
    usersSavedSoundStatus = _useState2[0];
  const soundEnabled = hasSound && (usersSavedSoundStatus !== null && usersSavedSoundStatus !== void 0 ? usersSavedSoundStatus : hasSoundDefaultOn);
  return {
    hasSound,
    hasSoundDefaultOn,
    setUsersSavedSoundStatus: setUsersPreferredSoundStatus,
    soundEnabled,
    usersSavedSoundStatus
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useSoundEnabled', useSoundEnabled);

 })(window);